module.exports = __webpack_public_path__ + "img/risk-asset-group.0a1e7e28.png";